import StaffCalendar from "@/components/StaffCalendar";
import { useAuth } from "@/contexts/AuthContext";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function StaffCalendarPage() {
  useDocumentTitle("Staff Calendar", "Manage internal team holidays, sick days and absences.");
  const { user } = useAuth();
  // Only admins / superadmins can edit the roster. Pure staff get a safe,
  // read-only view so the whole team can see who's off without being able
  // to tamper with each other's bookings.
  const canEdit = user?.role === "admin" || user?.role === "superadmin";
  return (
    <div className="space-y-4" data-testid="staff-calendar-page">
      <div>
        <h1 className="font-heading text-xl font-semibold">Staff Calendar</h1>
        <p className="text-xs text-muted-foreground mt-1">
          {canEdit
            ? "Track holidays, sick days and other absences for the internal team."
            : "Read-only view of the team's holiday rota. Book your own time off from the Holidays page."}
        </p>
      </div>
      <StaffCalendar isStaff={canEdit} />
    </div>
  );
}
